import { render } from "./BrandInstances.vue?vue&type=template&id=4c593776"
import script from "./BrandInstances.vue?vue&type=script&lang=js"
export * from "./BrandInstances.vue?vue&type=script&lang=js"

import "./BrandInstances.vue?vue&type=style&index=0&id=4c593776&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__